var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdfChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C0.899998 0 0.0100002 0.9 0.0100002 2L0 14.93C0 15.62 0.349999 16.23 0.879999 16.59L9 22L17.11 16.59C17.64 16.23 17.99 15.62 17.99 14.93L18 2C18 0.9 17.1 0 16 0ZM6.99 12.18L4.41 9.59L3 11L7 15L15 7L13.58 5.58L6.99 12.18Z",
    fill: "#419C44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41 9.59L6.99 12.18L13.58 5.58L15 7L7 15L3 11L4.41 9.59Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdfChecked);
export default __webpack_public_path__ + "static/media/EDF_checked.f9e02a6e3e8abb58849176e0560dd2f4.svg";
export { ForwardRef as ReactComponent };